import { create } from 'zustand'

import type { AuthCompany } from '../types/auth-company.type'

type State = {
  email?: string
  companies?: AuthCompany[]
  companySelected?: string
}

type Action = {
  setEmail: (email: string | undefined) => void
  setCompanies: (company: AuthCompany[] | undefined) => void
  setCompanySelected: (companySelected: string | undefined) => void
}

export const useLoginStore = create<State & Action>((set) => ({
  email: undefined,
  company: undefined,
  companySelected: undefined,

  setEmail: (email) => set((state) => ({ ...state, email })),
  setCompanySelected: (companySelected) =>
    set((state) => ({ ...state, companySelected })),
  setCompanies: (companies) => set((state) => ({ ...state, companies })),
}))
